//interface for columns
interface ColumnMeta {
    field: string;
    header: string;
}

// Role Columns
export const RoleColumns: ColumnMeta[] = [
    { field: 'role_name', header: 'Name' },
    { field: 'action', header: 'Action' }
];

// User Columns
export const UserColumns: ColumnMeta[] = [
    { field: 'full_name', header: 'Name' },
    { field: 'mobile', header: 'Mobile' },
    { field: 'user_permission', header: 'Permissions' },
    { field: 'status', header: 'Status' },
    { field: 'action', header: 'Action' }
];

// Inward List Columns
export const InwardListColumns: ColumnMeta[] = [
    { field: 'roll_id', header: 'Roll ID' },
    { field: 'product_id', header: 'Product' },
    { field: 'width', header: 'Width' },
    { field: 'length', header: 'Length' },
    { field: 'micron_gsm', header: 'Micron/GSM' },
    { field: 'is_owr', header: 'OWR' },
    { field: 'without_glase', header: 'Without Glase' },
    { field: 'scanned_by', header: 'Scanned By' },
    { field: 'scanned_at', header: 'Scanned At' },
    { field: 'status', header: 'Status' },
    { field: 'approved_by', header: 'Approved By' }
];
